export default {
  path: '/config',
  name: 'config_base',
  component: () => import('@/views/config/Base.vue'),
  children: [
    {
      path: 'order/templates',
      name: 'config_order_templates',
      component: () => import('@/views/config/OrderTemplateList.vue'),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: 'order/templates/new',
      name: 'config_order_template_new',
      component: () => import('@/views/config/OrderTemplateEdit.vue'),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: 'order/templates/:id',
      name: 'config_order_template_edit',
      component: () => import('@/views/config/OrderTemplateEdit.vue'),
      meta: {
        requireAuth: true,
      },
    },
  ],
}